import Component from '@glimmer/component';
import { TargetAudience } from 'common/enums/target-audience.enum';
import config from 'frontend/config/environment';

interface FormationPartsPriceComponentArgs {
  targetAudience: TargetAudience;
  isHttAccepted: boolean;
  numberOfHtt: string;
  price: number;
}

export default class FormationPartsPriceComponent extends Component<FormationPartsPriceComponentArgs> {
  get notJobseekerTargetAudience() {
    return this.args.targetAudience !== TargetAudience.Jobseeker;
  }

  get showHttSection() {
    if (this.args.numberOfHtt || this.args.isHttAccepted) {
      return true;
    }
    return false;
  }

  get showPriceBlock() {
    if (this.args.numberOfHtt || this.args.isHttAccepted || this.args.price) {
      return true;
    }
    return false;
  }

  get tarifUrl() {
    const frontUrl = `${config.wpUrl}/tarifs`;
    const targetAudience: TargetAudience = this.args.targetAudience;
    switch (targetAudience) {
      case TargetAudience.Jobseeker:
        return `${frontUrl}/demandeur-demploi`;
      case TargetAudience.Enterprise:
        return `${frontUrl}/travailleur`;
      case TargetAudience.Teacher:
        return `${frontUrl}/enseignant`;
      default:
        return frontUrl;
    }
  }
}
